import React from 'react';
import { LinkIcon as HeroLinkIcon } from '@heroicons/react/solid';
import { Icon, IconProps } from '../Icon';

type LinkIconProps = Omit<IconProps, 'children'>;

export const LinkIcon: React.FC<LinkIconProps> = (props) => {
    return (
        <Icon {...props}>
            <HeroLinkIcon />
        </Icon>
    );
};
